import { Map, Record } from "immutable";

import QuizModuleDetails from "./QuizModuleDetails";

export type QuizDetailsType = {
  title?: string;
  modules?: Map<string, QuizModuleDetails>;
  tags?: Map<string, string[]>;
};

export const defaultQuizDetails: QuizDetailsType = {
  title: undefined,
  modules: Map<string, QuizModuleDetails>(),
  tags: Map<string, string[]>()
};

export default class QuizDetails extends Record(defaultQuizDetails) {}
